import React, {useEffect, useState} from 'react';
import {styled} from 'baseui';

import {useIntercom} from 'react-use-intercom';
import {graphql, useStaticQuery} from 'gatsby';
import {PopupModal} from 'react-calendly';
import telephoneIcon from '../../svg/telephone.svg';
import messageIcon from '../../svg/message.svg';
import {handleMixpanelAnalytics, MixpanelEvents} from '../../utils/events';

const Wrapper = styled('div', ({$theme}) => ({
  padding: '32px 0px 32px 0px',
  display: 'flex',
  justifyContent: 'center',
  background: $theme.colors.white,
  alignItems: 'center',
  width: '100%',
  [$theme.mediaQuery.small]: {
    padding: '0',
  },
}));

const ICON_SIZE = 20;

const Icon = styled('img', {
  height: '20px',
  width: '20px',
  margin: '16px 16px 16px 0',
});

export const CardsWrapper = styled('div', ({$theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '32px',
  alignItems: 'center',
  padding: '0px 8px',
  [$theme.mediaQuery.small]: {
    flexDirection: 'column',
    gap: '16px',
  },
}));

export const Pressable = styled('button', ({$theme}) => ({
  padding: '0px',
  background: 'transparent',
  border: 'none',
  ':hover': {
    cursor: 'pointer',
  },
  [$theme.mediaQuery.small]: {
    width: '100%',
  },
}));

const Card = styled('div', ({$theme}) => ({
  padding: '4px 36px',
  backgroundColor: $theme.colors.accent,
  borderRadius: '8px',
  position: 'relative',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
}));

const Title = styled('h3', ({$theme}) => ({
  margin: 0,
  color: $theme.colors.white,
  fontSize: '16px',
  marginBottom: '4px',
  fontWeight: 600,
  textAlign: 'left',
}));

const Subtitle = styled('p', ({$theme}) => ({
  margin: 0,
  color: $theme.colors.white,
  opacity: 0.8,
  fontSize: '14px',
  fontWeight: 600,
}));

function MainShortcuts() {
  const intercom = useIntercom();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const data = useStaticQuery(graphql`
    query SupportShortcutsQuery {
      contentfulCallToAction {
        shortcut1Title
        shortcut1Subtitle
        shortcut2Title
        shortcut2Subtitle
        calendyUrl
      }
    }
  `);

  const {
    shortcut1Title,
    shortcut1Subtitle,
    shortcut2Title,
    shortcut2Subtitle,
    calendyUrl,
  } = data.contentfulCallToAction;

  const onCallPress = () => {
    handleMixpanelAnalytics(MixpanelEvents.CALL_REQUEST_STARTED);
    setIsModalOpen(true);
  };

  // Close Intercom buble if opened in "Contact";
  useEffect(() => {
    setIsLoaded(true);
    return () => intercom.hide();
  }, []);

  return (
    <>
      <Wrapper id='support_shortcuts'>
        <CardsWrapper>
          <Pressable onClick={() => {}}>
            <Card>
              <Icon
                width={ICON_SIZE}
                height={ICON_SIZE}
                src={messageIcon as unknown as string}
              />
              <div>
                <Title>{shortcut1Title}</Title>
                <Subtitle>{shortcut1Subtitle}</Subtitle>
              </div>
            </Card>
          </Pressable>
          <Pressable onClick={onCallPress}>
            <Card>
              <Icon
                width={ICON_SIZE}
                height={ICON_SIZE}
                src={telephoneIcon as unknown as string}
              />
              <div>
                <Title>{shortcut2Title}</Title>
                <Subtitle>{shortcut2Subtitle}</Subtitle>
              </div>
            </Card>
          </Pressable>
        </CardsWrapper>
      </Wrapper>
      {isLoaded ? (
        <PopupModal
          onModalClose={() => setIsModalOpen(false)}
          open={isModalOpen}
          rootElement={document.getElementById('support-root-wrapper')!}
          url={calendyUrl}
        />
      ) : null}
    </>
  );
}

export default MainShortcuts;
